import { Box, Typography, Paper } from '@mui/material';

export const MatchOversight = () => {
  return (
    <Paper sx={{ p: 3 }}>
      <Typography variant="h5" gutterBottom>
        Match Oversight Panel
      </Typography>
      <Typography color="text.secondary">
        Match management functionality coming soon...
      </Typography>
    </Paper>
  );
};